export enum DuplicateOrganizationStructureStatus {
    Unset = 0,
    ErrorHierarchyIdTaken = 1,
    ErrorHierarchyDescriptionTaken = 2,
    Success = 3,
    Failed = 4
}
